import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { investorLandingPage } from "./actions";
import { formDataGenerator, getRouting } from "../../../../utils/common";

const InvestorServices = (props) => {
  const {
    investorLandingPage,
    investorlandingData,
    location: { pathname },
  } = props;

  // const [learnData, setlearnData] = useState();
  const [mobileMain, setmobileMain] = useState(null);
  const [investorData, setinvestorData] = useState();
  const [metaData, setMetaData] = useState();

  useEffect(() => {
    if (investorlandingData && investorlandingData.landingpageinfo) {
      setinvestorData(investorlandingData.landingpageinfo);
    }

    if (investorlandingData && investorlandingData.landingpageinfo && investorlandingData.landingpageinfo.meta) {
      setMetaData(investorlandingData.landingpageinfo.meta);
    }
  }, [investorlandingData]);

  useEffect(() => {
    !(investorlandingData && investorlandingData.landingpageinfo) && investorLandingPage();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const handleExploreReadmore = async (e, value) => {
    var v = document.getElementById("moretext" + value);
    v.classList.add("autoHeight1");
  };
  const handleCollapseeReadLess = async (e, value) => {
    var v = document.getElementById("moretext" + value);
    v.classList.remove("autoHeight1");
  };

  const Mobileacord = (index) => {
    if (mobileMain === index) {
      return setmobileMain(null);
    }
    setmobileMain(index);
  };

  return (
    <div className="wrapper">
      {
        metaData ? (
          <Helmet>
            <title>{metaData && metaData.title ? metaData.title : ""}</title>
            <meta name="description"
              content={
                metaData && metaData.description ? metaData.description : ""
              }
            />
            <meta name="keywords"
              content={
                metaData && metaData.keywords ? metaData.keywords : ""
              }
            />
            <meta property="og:title"
              content={
                metaData && metaData.og_title ? metaData.og_title : ""
              }
            />
            <meta property="og:description"
              content={
                metaData && metaData.og_description ? metaData.og_description : ""
              }
            />
            <meta property="og:image"
              content={
                metaData && metaData.og_image ? metaData.og_image : ""
              }
            />
            <meta property="og:url"
              content={
                metaData && metaData.og_url ? metaData.og_url : ""
              }
            />
          </Helmet>
        ) : ("")
      }

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              <span>Investor</span> Services
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  Investor Services
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="InvestorCards">
        <div className="container">
          <div className="row">
            {investorData &&
              investorData.investorNav &&
              investorData.investorNav.length > 0 &&
              investorData.investorNav.map((item, index) => (
                <div className="col-md-4">
                  <div id={`card${index}`} className="card" key="0">
                    <div className="cardHead d-flex">
                      <div className="align-self-center">
                        <img src={item.icon ? item.icon : ""} alt={item.iconAlt ? item.iconAlt : ""} />
                      </div>
                      <div className="ms-3 align-self-center">
                        <p>{item.title ? item.title : ""}</p>
                        <p className="subheading">
                          {item.description ? item.description : ""}
                        </p>
                      </div>
                    </div>
                    {item.linkUrl === null ? (
                      <div className="cardFooter">
                        <div
                          id={`moretext${index}`}
                          className="moretext ps-0 mb-2"
                        >
                          <div
                            className="accordion mb-4"
                            id={`accordionHome${index}`}
                          >
                            <div className="accordion-item border-0">
                              <div>
                                {item.links &&
                                  item.links.length > 0 &&
                                  item.links.map((link, linkindex) => (
                                    <>
                                      <div className="main">

                                        <a href={link.uri ? link.uri : ""}>
                                          <div className="d-flex justify-content-between w-100">
                                            <p>{link.title ? link.title : ""}</p>
                                            <img
                                              src="/images/New/red-right-arrow.png"
                                              width={14}
                                              height={14}
                                            />
                                          </div>
                                        </a>
                                        {
                                          link.additionalUrl && link.additionalUrl.length > 0 ?
                                            <div className="listing mt-3">
                                          

                                              {link.additionalUrl &&
                                                link.additionalUrl.length > 0 &&
                                                link.additionalUrl.map(
                                                  (child, childindex) => (
                                                    <>
                                                      <div>
                                                        <a
                                                          href={child.link &&
                                                            child.link.uri ? child.link.uri : ""
                                                          }
                                                        >
                                                          <img className="me-2" src={child.link && child.link.iconUrl ? child.link.iconUrl : ''}
                                                            alt={child.link && child.link.iconAlt ? child.link.iconAlt : ''} width={20} height={20}/>
                                                          {child.link && child.link.title
                                                            ? child.link.title
                                                            : ""}
                                                        </a>
                                                      </div>
                                                    </>
                                                  )
                                                )}
                                            </div> : ""
                                        }

                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleExploreReadmore(e, index)}
                          className="lessMoreArrow1 readMore1 position-relative"
                        >
                          <p className="more p_primary">Collapse</p>
                        </a>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => handleCollapseeReadLess(e, index)}
                          className="lessMoreArrow1 readLess1 position-relative"
                        >
                          <p className="less p_primary">Explore</p>
                        </a>
                      </div>
                    ) : (
                      <div className="cardFooter">
                        <a
                          href={item.linkUrl ? item.linkUrl : ""}
                          className="lessMoreArrow1 rightarrow readMore1 position-relative"
                        >
                          <p className="more p_primary">Explore</p>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      <section className="mobile-view">
        <div className="container">
          <div className="accordian aboutmobileacord mt-4">
            {investorData &&
              investorData.investorNav &&
              investorData.investorNav.length > 0 &&
              investorData.investorNav.map((mobitem, mobindex) => (
                <div className="item">
                  {mobitem.linkUrl === null ? (
                    <>
                      <div
                        className="title"
                        onClick={() => Mobileacord(mobindex)}
                      >
                        <div className="d-flex align-items-center align-self-center">
                          <img src={mobitem.icon ? mobitem.icon : ""} alt={mobitem.iconAlt ? mobitem.iconAlt : ""} />
                          <div className="ms-3 align-self-center">
                            <p>{mobitem.title ? mobitem.title : ""}</p>
                            <p className="subheading">
                              {mobitem.description ? mobitem.description : ""}
                            </p>
                          </div>
                        </div>

                        <div className="accordarrow">
                          <img
                            className={mobileMain === mobindex ? "rotate" : ""}
                            src="/images/New/redDownArrow.svg"
                          />
                        </div>
                      </div>
                      <div
                        className={
                          mobileMain === mobindex ? "content show" : "content"
                        }
                      >
                        <div className="ps-0 mb-2">
                          <div>
                            {mobitem.links &&
                              mobitem.links.length > 0 &&
                              mobitem.links.map((link, linkindex) => (
                                <>
                                  <div className="mobile-main">
                                    <a href={link.uri ? link.uri : ""}>
                                      <div className="d-flex justify-content-between w-100">
                                        <p>{link.title ? link.title : ""}</p>
                                        <img
                                          src="/images/New/red-right-arrow.png"
                                          width={14}
                                          height={14}
                                        />
                                      </div>
                                    </a>
                                    {
                                      link.additionalUrl && link.additionalUrl.length > 0 ?
                                        <div className="listing mt-3">
                                          {link.additionalUrl &&
                                            link.additionalUrl.length > 0 &&
                                            link.additionalUrl.map(
                                              (child, childindex) => (
                                                <>
                                                  <div>
                                                    <a
                                                      href={child.link &&
                                                        child.link.uri ? child.link.uri : ""
                                                      }
                                                    >
                                                       <img src={child.link && child.link.iconUrl ? child.link.iconUrl : ''} alt={child.link && child.link.iconAlt ? child.link.iconAlt : ''} width={20} height={20} className="me-2"/>
                                                      {child.link && child.link.title ? child.link.title : ""}
                                                    </a>
                                                  </div>
                                                </>
                                              )
                                            )}
                                        </div> : ""
                                    }
                                  </div>
                                </>
                              ))}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <a href={mobitem.linkUrl ? mobitem.linkUrl : ''}>
                      <div className="title">
                        <div className="d-flex align-items-center align-self-center">
                          <img src={mobitem.icon ? mobitem.icon : ""} alt={mobitem.iconAlt ? mobitem.iconAlt : ""} />
                          <div className="ms-3 align-self-center">
                            <p>{mobitem.title ? mobitem.title : ""}</p>
                            <p className="subheading">
                              {mobitem.description ? mobitem.description : ""}
                            </p>
                          </div>
                        </div>
                        <div className="accordarrow">
                          <img
                            className="rightArrow"
                            src="/images/New/redDownArrow.svg"
                          />
                        </div>
                      </div>
                    </a>

                  )}
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};
const mapStateToProps = (state) => ({
  investorlandingData: state.InvesterServices,
});

const mapDispatchToProps = (dispatch) => ({
  investorLandingPage: bindActionCreators(investorLandingPage, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestorServices);
